import React, { FC } from 'react';
import { DropdownSelect } from './DropdownSelect';

type DropdownMenuProps = React.HTMLProps<HTMLSelectElement>;

export const DropdownMenu: FC<DropdownMenuProps> = props => {
  const onChange: DropdownMenuProps['onChange'] = ev => {
    const option = ev.currentTarget.options[ev.currentTarget.selectedIndex];
    if (option.disabled) {
      ev.preventDefault();
      return;
    } else {
      if (props.onChange) {
        props.onChange(ev);
      }
    }
  };
  return <DropdownSelect {...props} onChange={onChange}></DropdownSelect>;
};
